<template>
  <div class="m-l-30 m-r-30 card card-1 m-b-30">
     <div class="card-body">
        <h2 class="m-b-20">Update Searched Data</h2>
        <h4 class="m-b-30">
          <span class="text-danger">Proceed with caution.</span> Action will take place on <span class="text-danger">{{ searchResultCount }}</span> rows of records
        </h4>
        <b-row>
          <b-col cols="4" class="shipping-fields">
              <label for="">Select Country</label>
              <autocomplete
                placeholder="Set Country"
                :source="allCountries"
                @selected="shippedFromChanged"
                @clear="shippedFromCleared"
                >
              </autocomplete>
          </b-col>
          <b-col cols="4" >
             <label for="">Enter Tags</label>
             <b-form-input class="input-fields" v-model="updateFields.tags" placeholder="Enter Tags"></b-form-input>
             <b-form-group class="m-t-10" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-1"
                  v-model="updateFields.tagAction"
                  :options="options"
                  :aria-describedby="ariaDescribedby"
                  name="radio-options"
                ></b-form-radio-group>
              </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-overlay
                :show="inProgress"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="primary"
                class="d-inline-block"
                @hidden="onHidden"
              >
              <b-btn ref="button" variant="primary" class="pq-bulk-update-trigger" @click="updateSearchData" :disabled="inProgress"><i class="fa fa-arrow-right" aria-hidden="true"></i></b-btn>
            </b-overlay>
          </b-col>
        </b-row> 
     </div>

     
  </div>
</template>

<script>
import Autocomplete from 'vuejs-auto-complete'
import ItemListService from '../../services/item-list.service'
import EventBus from '../../EventBus'

  export default {
    data(){
      return {
          updateFields: {
            tags: '',
            tagAction: 'add',
            shippedFrom: null
          },
          options: [
            { text: 'Add', value: 'add' },
            { text: 'Remove', value: 'remove' },
          ],
          inProgress: false
      }
    },
    props:{
      searchResultCount: {
         type: Number,
         default: 0
      },
      searchFilters:{
        type: Object,
        default: null
      }
    },
    components: {Autocomplete},
    methods: {
      shippedFromChanged(countryData){
          this.updateFields.shippedFrom = countryData.value;
      },
      shippedFromCleared(){
           this.updateFields.shippedFrom = null
      },
      async updateSearchData(){
         this.inProgress = true;
         try{
           const data = {
            searchFilters: this.searchFilters,
            ...this.updateFields
         }
        
         const result = await ItemListService.updateSearchedItems(data)

         EventBus.$emit('print-queue.updated-items');

         this.$toasted.show("Updated Searched Print Queue Items", {
              action: {
                text: "Cancel",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
              duration: 5000,
            });
          
         

        }catch(errors){
           console.log(errors)
        }finally {
           this.inProgress = false;
        }
         
         
      },
      onHidden() {
        // Return focus to the button once hidden
        this.$refs.button.focus()
      },
    },
    computed:{
      allCountries(){
            return this.$store.state.itemsList.countries
        }
    }
  }
</script>

<style lang="scss" scoped>
 .input-fields{
    height: 40px;
    border-radius: 5px;
  }
  .pq-bulk-update-trigger{
     padding: 11px;
     margin-top: 32px;
  }
</style>